import { Link } from "react-router-dom";
import { Flame, ArrowRight } from "lucide-react";
import { ArticleCard } from "@/components/ArticleCard";
import { usePopularArticles } from "@/hooks/useArticles";

export function PopularArticlesSection() {
  const { data: popularArticles, isLoading } = usePopularArticles(4);

  // Don't show section if no popular articles or all have 0 views
  if (!isLoading && (!popularArticles || popularArticles.length === 0)) {
    return null;
  }

  return (
    <section className="py-12 md:py-16 bg-background">
      <div className="container">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-destructive/10">
              <Flame className="w-5 h-5 text-destructive" />
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground">
                Populært lige nu
              </h2>
              <p className="text-muted-foreground mt-1">
                Se hvad andre læser
              </p>
            </div>
          </div>
          <Link 
            to="/kategori/sabbataar-intro"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary/80 transition-colors"
          >
            Se alle
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {isLoading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="bg-card rounded-2xl animate-pulse">
                <div className="aspect-[16/10] bg-muted rounded-t-2xl" />
                <div className="p-4 space-y-3">
                  <div className="h-4 w-16 bg-muted rounded-full" />
                  <div className="h-5 w-3/4 bg-muted rounded" />
                  <div className="h-3 w-full bg-muted rounded" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {popularArticles?.map((article, index) => (
              <ArticleCard 
                key={article.id} 
                article={article}
                colorAccent={["coral", "marine", "sage", "sky"][index % 4]}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default PopularArticlesSection;
